import React from 'react';
import { TestimonialCard } from './TestimonialCard';
import { heroTestimonials } from '../data/salesData';
export function HeroTestimonials() {
  return <section className="border-b border-[var(--violet)]/30 py-12" data-id="element-131" data-mp="12u0f8kkmppfi">
      <div className="mx-auto max-w-6xl px-4" data-id="element-132" data-mp="xzw8a1bd5hef">
        <div className="grid gap-5 md:grid-cols-3" data-id="element-133" data-mp="tzls5vtuxalu">
          {heroTestimonials.map(t => <TestimonialCard key={t.name} testimonial={t} showLocation={false} data-id="element-134" data-mp="txsrqy9u7mma" />)}
        </div>
      </div>
    </section>;
}